import React from "react";
import {Button, Col, Row} from "react-bootstrap";
import {ResponseType} from "./ResponseType";

const NotFound = (props:ResponseType) => {
    return(
        <Row className={"justify-content-center"}>
            <Col xs={12} sm={11} md={9} lg={7} className={"text-center"}>
                <p className={"lead"}>Según nuestros registros usted no está habilitado para participar en esta votación</p>
                <Button className="EvColorGrisLight m-1" onClick={props.volver}
                        variant="light">VOLVER A CONSULTAR</Button>
            </Col>
        </Row>
    )
}

export default NotFound;